import { useState } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import ConfigAccordionBase from './ConfigAccordionBase';
import { Text } from '../../1elements';
import MarkerListEditor from '../../../v2/components/MarkerListEditor';
import MapMarkerPicker from '../../../v2/components/MapMarkerPicker';
import MarkerStyleSelector from './MarkerStyleSelector';


const MarkerConfigAccordion = ({ onEditMode, options, setOptions }) => {
  const [selectedRow, setSelectedRow] = useState('Default Marker');

    const selectedMarker = options[selectedRow];
    const classes = useStyles()

  const updateMarker = (data) => {
    setOptions((prev) => {
      const updatedData = Object.assign({}, prev[selectedRow], data);
      return {
        ...prev,
        [selectedRow]: {
          ...updatedData
        }
      };
    });
  };

    return (
        <ConfigAccordionBase className={classes.root} label={'Marker'} onEditMode={onEditMode}>
            <div>
              <Text type={'h9'}>Marker</Text>
              <MarkerListEditor options={options} selectedRow={selectedRow} setSelectedRow={setSelectedRow}
                                className={classes.editorList} onEditMode={onEditMode} excludeKeys={['industryTypeIcons', 'entityTypeColors', 'executiveEntityMarkers']} />
            </div>
            {
                onEditMode && (
                    <>
                        <div>
                            <Text type={'h9'}>Marker Style</Text>
                            <MarkerStyleSelector selectedRow={selectedRow} options={options} setOptions={setOptions} />
                        </div>
                        <div>
                            <Text type={'h9'}>Color & Icon</Text>
                            <MapMarkerPicker selectedMarker={selectedMarker} updateMarker={updateMarker} />
                        </div>
                    </>
                )
            }

        </ConfigAccordionBase>
    )
}

export default MarkerConfigAccordion

const useStyles = makeStyles({
    root: {
        display: 'grid',
        gridTemplateColumns: '1fr 1fr 1fr',
        gap: 20,
        maxWidth: '98%',
        '&>div>p': {
            marginBottom: 30
        }
    },
    editorList: {
        width: 200,
        maxHeight: 200
    },
})
